
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import ScoreTypeRepositoryInterface, { ScoreTypeInterface } from '@/services/QA/scoreType/interfaces';
import { EditScoreTypeForm } from '@/services/QA/scoreType/forms/EditScoreTypeForm';

@Component({
  inject: [
    'scoreTypeRepository',
  ],
})
export default class EditScoreType extends Vue {
  private scoreType!: ScoreTypeInterface;
  private readonly scoreTypeRepository!: ScoreTypeRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<EditScoreTypeForm> = new WPXFormValue(EditScoreTypeForm);


  public async created(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  private async initialize(): Promise<void> {
    if (!this.$route.params.scoreTypeId) {
      this.$errorDialog.show('Score Type Id Not Provided!');
      return;
    }

    this.scoreType = await this.scoreTypeRepository.getOneById(Number(this.$route.params.scoreTypeId));
    this.form.data.label = this.scoreType.label;
  }

  private async editScoreType(): Promise<void> {
    try {
      await this.scoreTypeRepository.editScoreType(this.scoreType.id, {
        label: this.form.data.label,
      });

      this.$successDialog.show(`Score Type '${this.form.data.label}' has been edited`);
    } catch (err) {
      this.$errorDialog.show(err.response?.data?.message);
    }
  }
}
